// extracted by mini-css-extract-plugin
export default {"position":"Chevron_position__7nNpK","position__rotate":"Chevron_position__rotate__sQjUk"};